let infoTranslations = ''
if(document.documentElement.lang == 'cn'){
    infoTranslations = window.trans.lms.Show + ' _TOTAL_ ' + window.trans.lms.Entries_cn + ' _START_ ' + window.trans.lms.Of_cn + ' _END_ ' + window.trans.lms.Individual_cn;
}else{
    infoTranslations = window.trans.lms.Showing + ' _START_ ' + window.trans.lms.to + ' _END_ ' + window.trans.lms.of + ' _TOTAL_ ' + window.trans.lms.entries;
}
const config = {
    dom: '<"datatables-search"<lB>f>r<"custom-table-wrapper"t><"datatables-footer"ip>',
    deferRender: true,
    autoWidth: false,
    buttons: [],
    order: [0, 'asc'],
    responsive: true,
    language: {
        processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">'+ window.trans.lms.Loading +'</span>',
        search: window.trans.lms.Search,
        paginate: {
            next: window.trans.lms.Next,
            previous: window.trans.lms.Previous
        },
        emptyTable: window.trans.lms.EmptyTable,
        infoEmpty: window.trans.lms.InfoEmpty,
        lengthMenu: window.trans.lms.Show + ' _MENU_ ' + window.trans.lms.entries,
        info: infoTranslations,
        infoFiltered: window.trans.lms.filteredFrom + ' _MAX_ ' + window.trans.lms.total +' '+ window.trans.lms.entries,
        zeroRecords: window.trans.lms.ZeroRecords,
    },
    pageLength: 10,
    drawCallback: function() {
        let api = this;
        var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
        var info = $(this).closest('.dataTables_wrapper').find('.dataTables_info');
        pagination.toggle(this.api().page.info().pages > 1);
        // info.toggle(this.api().page.info().pages > 1);
        let nextButton = pagination.find('.next');
        if(nextButton){
            let max = Number(this.api().page.info().pages) ? Number(this.api().page.info().pages) : 1;
            let element = '<li class="paginate_button page-item"><input autocomplete="off" class="jump-to-page" type="number" min="1" max="'+ max +'" value="'+ Number(this.api().page() + 1) +'"></input></li>';
            nextButton.after(element);
            $('.jump-to-page').on('change', function(e){
                window.goToPage(api);
            });
        }
    },
    createdRow: function (row, data, dataIndex) {
        let did = (data.cid || data.temi || data.uppid || data.cmid) + "" + (data.uid || data.id);
        $(row).attr('data-id', data.id);
        $(row).attr('id', did);
    }
}
/**
 * 
 * @param {*} options -- object with options to override default config
 * @returns 
 */
window.setDatatableOptions = function(options){
    const datatableOptions = {};
    for(const property in config){
        datatableOptions[property] = config[property];
        if(property == 'pageLength'){
            datatableOptions[property] = sessionStorage.getItem('pageLength') ? Number(sessionStorage.getItem('pageLength')) : Number(window.datatablesConfig[property]);
        }
    }
    for(const property in options){
        datatableOptions[property] = options[property];
    }
    
    datatableOptions['initComplete'] = function () {
        $(this.api().table().container()).find('input').attr('autocomplete', 'off');
        let tableContainer = options && options.tableContainer ? options.tableContainer : 'table';
        hideDtLoader(tableContainer);
        let allTables = $.fn.dataTable.tables();
        allTables.forEach(function(table){
            $('#' + table.id).on('length.dt', function () { // check if jquery can be removed here
                let select = document.getElementsByName(table.id + "_length")[0];
                if(typeof select !== 'undefined'){
    
                    let newValue = select.options[select.selectedIndex].value;
    
                    // send AJAX request for updating session values
                    updateShowEntries(newValue);
                }
            })
        });
    }

    datatableOptions['drawCallback'] = config.drawCallback;
    return datatableOptions;
}

function hideDtLoader(container){
    let spinner = document.getElementById(container+"_loader");
    let pageContainer = document.getElementById(container);
    if(pageContainer){
        pageContainer.style = "visibility: visible";
        pageContainer.classList.add('dt_expand');
    }
    if(spinner){
        spinner.style = "visibility: hidden";
    }
}

function updateShowEntries(newValue) {
    // send AJAX request for updating session values
    $.ajax({
        type: 'PUT',
        url: '/entries/show',
        data: {
            'entries': newValue
        },
        success: function () {
            document.body.dataset.entries = newValue;
            sessionStorage.setItem('pageLength', newValue);
        }
    });
}

window.goToPage = function(table){
    let value = Number(event.target.value) - 1;
    if(value < 0){
        value = 0;
    }
    table.api().page(value).draw(false);
}
window.hideDtLoader = hideDtLoader;
window.datatablesConfig = config;


// WEBPACK FOOTER //
// ./resources/assets/js/datatables-config.js